<template>
    <component :is="component">
        <slot/>
    </component>
</template>

<style>
    @font-face {
        font-family: 'regularFont';
        src: url('./assets/fonts/neris-light.otf') format('opentype');
        font-weight: normal;
    }

    @font-face {
        font-family: 'boldFont';
        src: url('./assets/fonts/neris-black.otf') format('opentype');
        font-weight: bold;
    }

    .application {
        font-family: regularFont;
        background-color: transparent !important;
        font-size: 14px;
    }

    .swal2-container {
        font-family: regularFont;
    }

    .text-bold {
        font-family: boldFont;
    }

    .text-success {
        text-align: center;
        color: #28a745;
    }

    .container {
        padding: 20px !important;
        height: 100%;
    }

    button {
        font-family: boldFont;
        text-transform: initial !important;
    }

    button:not(.radius-inline) {
        border-radius: 25px !important;
    }

    a {
        text-decoration: underline;
    }

    .app-container {
        padding: 0 20px !important;
    }

    .app-processing {
        font-size: 16px;
        text-align: center;
        padding: 40px 10px;
    }

    .app-error-info {
        font-size: 14px;
        color: #888;
        text-align: center;
        padding: 20px;
    }

    .app-error-info>div {
        margin-top: 5px;
    }

    .app-title {
        font-size: 18px;
        text-align: center;
        margin-bottom: 5px;
    }

    .app-title-centered {
        font-size: 18px;
        text-align: center;
        padding: 40px 10px 10px;
    }

    .app-subtitle {
        font-size: 16px;
        text-align: center;
    }

    .app-info {
        padding: 20px 0;
        text-align: center;
    }

    .app-image {
        text-align: center;
        padding: 40px 0 20px;
    }

    .app-image img {
        width: 200px;
        max-width: 100%;
    }

    .app-message {
        padding: 80px 20px;
        text-align: center;
        font-size: 16px;
    }

    .app-footer {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin: 10px 0 20px;
    }

    .app-footer>div {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .app-footer button svg:first-child {
        margin-right: 7px;
    }

    .app-footer button {
        width: 100%;
        margin: 5px 0;
        font-size: 16px !important;
        height: 40px;
    }

    .app-photos {
        margin: 20px 0;
    }

    .form-row {
        padding: 5px 0;
        position: relative;
    }

    .form-row-title {
        margin-bottom: 5px;
        display: flex;
    }

    .form-row .v-input {
        padding: 0 !important;
        margin: 0 !important;
    }

    .form-row>div:not(.v-textarea) {
        min-height: 40px !important;
        height: 40px !important;
        max-height: 40px !important;
    }

    .form-row .v-input:not(.v-textarea) .v-input__control {
        margin: 0 !important;
        min-height: 40px !important;
        height: 40px !important;
        max-height: 40px !important;
    }

    .form-row .v-input:not(.v-textarea) .v-input__slot {
        margin: 0 !important;
        min-height: 100% !important;
        height: 100% !important;
        max-height: 100% !important;
        box-shadow: none !important;
        outline: none !important;
    }

    .form-row .v-input .v-input__slot {
        background-color: #fff !important;
    }

    .form-row .v-text-field--outline>.v-input__control>.v-input__slot {
        background-color: #fff !important;
    }

    .form-row .v-input:not(.v-textarea) input {
        margin: 0 !important;
        padding-top: 0 !important;
        padding-bottom: 0 !important;
        min-height: 100% !important;
        height: 100% !important;
        max-height: 100% !important;
    }

    .form-row .v-input:not(.v-textarea) .v-input__append-inner {
        margin-top: 7px !important;
    }

    .form-row textarea {
        padding: 12px;
        min-height: 100px;
    }

    .form-row .v-autocomplete .v-select__slot>input  {
        pointer-events: none !important;
    }

    .form-row .v-select__selections {
        padding: 0 !important;
    }

    .form-row .v-select__selection--comma {
        margin: 0 !important;
    }

    .form-row-input-password input {
        padding-right: 20px !important;
    }

    .form-row-password-icon {
        position: absolute;
        top: 40px;
        right: 10px;
        cursor: pointer;
        color: #888;
    }

    .form-row .v-select .v-input__icon svg {
        height: 16px;
    }

    .v-dialog {
        margin: 0 auto !important;
    }

    .app-buttons-flex {
        padding-top: 20px;
    }

    .app-buttons-flex>div {
        width: calc(50% - 20px);
        margin: 10px;
        height: 120px;
        font-family: boldFont;
        text-transform: initial;
        font-size: 18px;
        border-radius: 25px;
        cursor: pointer;
        text-align: center;
    }

    .app-buttons-flex-small>div {
        min-height: 60px;
        font-size: 12px;
        height: auto;
        padding-top: 5px;
        padding-bottom: 5px;
    }

    .app-buttons-flex-small>div>div {
        font-size: 12px !important;
    }

    .app-button-card {
        flex-direction: column;
    }

    .app-button-card>div:first-child {
        font-size: 15px;
    }

    .app-button-element {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 15px;
    }

    .app-subscription-button-link {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 40px 0 20px;
    }

    .sequra-checkout {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background: #fff;
        z-index: 100000;
        overflow: auto;
    }

    .sequra-checkout iframe {
        display: block !important;
    }
</style>

<script>
    import VuebaseLayout from './layouts/VuebaseLayout'
    import Utils from './services/Utils'

    export default {
        name: 'App',
        components: {
            VuebaseLayout
        },
        computed: {
            component() {
                return VuebaseLayout
            }
        },
        beforeMount: function () {
            Utils.initialize()
        }
    }
</script>
